document.addEventListener('DOMContentLoaded', function () {
  const MAKE_WEBHOOK_URL = 'https://hook.eu1.make.com/4kt3koq8w5mteoe6nstrpb9wzwpx9h8n';

  document.querySelectorAll('product-form').forEach(function (productForm) {
    const box = productForm.querySelector('[data-kaptex-back-in-stock]');
    if (!box) return;

    const openButton = box.querySelector('[data-kaptex-notify-open]');
    const notifyForm = box.querySelector('[data-kaptex-notify-form]');
    const emailInput = box.querySelector('[data-kaptex-notify-email]');
    const submitButton = box.querySelector('[data-kaptex-notify-submit]');
    const messageBox = box.querySelector('[data-kaptex-notify-message]');

    const productIdField = box.querySelector('[data-kaptex-product-id]');
    const variantIdField = box.querySelector('[data-kaptex-variant-id]');
    const productTitleField = box.querySelector('[data-kaptex-product-title]');
    const variantTitleField = box.querySelector('[data-kaptex-variant-title]');
    const productUrlField = box.querySelector('[data-kaptex-product-url]');

    const productJsonElement = productForm.querySelector('[data-product-json]');
    const shopifyVariantInput = productForm.querySelector('input[name="id"]');

    if (!productJsonElement || !shopifyVariantInput) return;

    let productData;

    try {
      productData = JSON.parse(productJsonElement.textContent);
    } catch (error) {
      console.error(
        'Kaptex Back in Stock: Produktdaten konnten nicht gelesen werden.'
      );
      return;
    }

    function updateBackInStock() {
      const currentVariantId = String(shopifyVariantInput.value);

      const currentVariant = productData.variants.find(function (variant) {
        return String(variant.id) === currentVariantId;
      });

      if (!currentVariant) return;

      variantIdField.value = currentVariant.id;

      if (variantTitleField) {
        variantTitleField.value = currentVariant.title;
      }

      if (currentVariant.available) {
        box.hidden = true;
        notifyForm.hidden = true;
        openButton.hidden = false;
      } else {
        box.hidden = false;
      }
    }

    openButton.addEventListener('click', function () {
      notifyForm.hidden = false;
      openButton.hidden = true;

      if (emailInput) {
        emailInput.focus();
      }
    });

    submitButton.addEventListener('click', async function () {
      const email = emailInput.value.trim();

      messageBox.hidden = true;

      if (!email || !emailInput.checkValidity()) {
        messageBox.textContent =
          'Bitte gib eine gültige E-Mail-Adresse ein.';
        messageBox.hidden = false;
        emailInput.focus();
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = 'WIRD EINGETRAGEN...';

      const data = new URLSearchParams();

      data.append('email', email);
      data.append('product_id', productIdField.value);
      data.append('product_title', productTitleField.value);
      data.append('variant_id', variantIdField.value);
      data.append('variant_title', variantTitleField.value);
      data.append('product_url', productUrlField.value);
      data.append('created_at', new Date().toISOString());

      try {
        await fetch(MAKE_WEBHOOK_URL, {
          method: 'POST',
          body: data,
          mode: 'no-cors'
        });

        messageBox.textContent =
          '✓ Vielen Dank! Wir informieren dich, sobald dieser Artikel wieder verfügbar ist.';
        messageBox.hidden = false;

        emailInput.value = '';
        submitButton.textContent = 'EINGETRAGEN ✓';
      } catch (error) {
        console.error('Kaptex Back in Stock:', error);

        messageBox.textContent =
          'Die Anmeldung konnte gerade nicht gespeichert werden. Bitte versuche es erneut.';
        messageBox.hidden = false;

        submitButton.disabled = false;
        submitButton.textContent = 'BENACHRICHTIGE MICH';
      }
    });

    productForm.addEventListener('change', function () {
      setTimeout(updateBackInStock, 50);
    });

    const observer = new MutationObserver(function () {
      updateBackInStock();
    });

    observer.observe(shopifyVariantInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    updateBackInStock();
  });
});